import styled, { keyframes } from "styled-components";

const slideUp = keyframes`
  from {
    transform: translateY(16px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Container = styled.aside`
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 9999;
  width: min(440px, calc(100% - 3rem));
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid rgba(14, 34, 68, 0.08);
  box-shadow:
    0 24px 54px rgba(14, 34, 68, 0.12),
    0 8px 24px rgba(14, 34, 68, 0.08);
  padding: 1.5rem;
  animation: ${slideUp} 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  h3 {
    margin: 0;
    color: var(--background-button-component);
    font-size: 1.15rem;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  p {
    margin: 0;
    color: #4a5568;
    line-height: 1.5;
    font-size: 0.95rem;
  }

  @media screen and (max-width: 540px) {
    left: 1rem;
    right: 1rem;
    bottom: 1rem;
    width: auto;
    padding: 1.25rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f4f8;
    color: var(--background-button-component);
    padding: 0.6rem;
    border-radius: 50%;
  }
`;

export const Actions = styled.div`
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;

  button {
    border: none;
    border-radius: 8px;
    padding: 0.65rem 1.2rem;
    font-size: 0.9rem;
    font-weight: 600;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    cursor: pointer;
  }

  .button-preferences {
    background: transparent;
    color: #4a5568;
    border: 1px solid #cbd5e1;

    &:hover {
      background: #f8fafc;
      color: var(--background-button-component);
      border-color: #94a3b8;
    }
  }

  .button-accept {
    background: var(--background-button-component);
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(14, 34, 68, 0.15);

    &:hover {
      filter: brightness(1.15);
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(14, 34, 68, 0.2);
    }
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(14, 34, 68, 0.15);
    }
  }

  @media screen and (max-width: 540px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

const fadeInDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const PreferencesArea = styled.div`
  margin-top: 0.5rem;
  padding-top: 1.25rem;
  border-top: 1px dashed #dbe2ee;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  animation: ${fadeInDown} 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  .pref-item {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 0.9rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    transition: border-color 0.2s ease;

    &:hover {
      border-color: #cbd5e1;
    }
  }

  .pref-text {
    display: flex;
    flex-direction: column;

    strong {
      font-size: 0.95rem;
      color: var(--background-button-component);
      font-weight: 700;
    }
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    flex-shrink: 0;

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #cbd5e1;
      transition: 0.3s;
      border-radius: 24px;

      &:before {
        position: absolute;
        content: "";
        height: 18px;
        width: 18px;
        left: 3px;
        bottom: 3px;
        background-color: white;
        transition: 0.3s;
        border-radius: 50%;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
      }
    }

    input:checked + .slider {
      background-color: var(--background-button-component);
    }

    input:checked + .slider:before {
      transform: translateX(20px);
    }

    input:disabled + .slider {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  @media screen and (max-width: 540px) {
    .pref-item {
      flex-direction: row;
      align-items: center;
      gap: 0.8rem;
    }
  }
`;
